import firebase from 'firebase';

const config = {
	apiKey: "AIzaSyBMVLTJ2oGTHqJVklHXBlJiIJbl8W_xVWI",
    authDomain: "andrideng-com.firebaseapp.com",
    databaseURL: "https://andrideng-com.firebaseio.com",
    projectId: "andrideng-com",
    storageBucket: "andrideng-com.appspot.com",
    messagingSenderId: "629240190321"
};

firebase.initializeApp(config);

export const ref = firebase.database().ref();
export const firebaseAuth = firebase.auth


// WEBPACK FOOTER //
// ./src/config/firebase.js